import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, FormControl, TextField, Radio, FormControlLabel } from '@material-ui/core';
import VariantSnackbar from '../share/VariantSnackbar';
import Utils from '../share/Utils';
import AssistenciaOdontoService from '../../services/AssistenciaOdontoService';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  checkBox: {
    marginLeft: theme.spacing.unit,
  },
  textFieldNomDentista: {
    width: 510,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit,
  },
  controlRadio: {
    width: 500,
    marginLeft: theme.spacing.unit,
    display: 'inLine-block',
    marginBottom: theme.spacing.unit * -1.5,
  },
  radio: {
    marginLeft: theme.spacing.unit * 6,
    marginBottom: theme.spacing.unit * 0.5,
  },
  textFieldCpfCnpj: {
    width: 180,
    marginTop: theme.spacing.unit * 2,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  textFieldNumCro: {
    width: 100,
    marginTop: theme.spacing.unit * 2,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  textFieldTelefone: {
    width: 180,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
  },
});
class FormDialogDentista extends React.Component {
  assistenciaOdontoService = new AssistenciaOdontoService();
  utils = new Utils();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.dentista,
      fetching: false,
      snackOpen: false,
      snackMessage: '',
      sucesso: false,
      errorMessageNome: '',
      errorMessageTelefone: '',
      errorMessageCpfCgc: '',
      indPessoaFisica: 'N',
      valueRadio: 'N',
      cpfCgcInicial: this.props.dentista.numCpfCgc === undefined ? '' : this.props.dentista.numCpfCgc,
      indPessoaFisicaInicial: 'N',
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  handleChangeTextField = event => {
    var novoValor = event.target.value;
    if (event.target.name === 'nomDentista') {
      this.setState({ [event.target.name]: event.target.value.toUpperCase(), errorMessageNome: '' });
    }
    if (event.target.name === 'numCpfCgc') {
      if (this.state.indPessoaFisica === 'N' || this.state.indPessoaFisica === undefined) {
        novoValor = this.utils.formatCNPJTextField(novoValor, event.target.defaultValue);
      } else {
        novoValor = this.utils.formatCPFTextField(novoValor, event.target.defaultValue);
      }
      this.setState({ [event.target.name]: novoValor, errorMessageCpfCgc: '' });
    }
    if (event.target.name === 'numFone') {
      novoValor = event.target.value !== '' ? this.utils.formataTelefoneTextField(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: novoValor, errorMessageTelefone: '' });
    }
    if (event.target.name === 'numCro') {
      novoValor = event.target.value !== '' ? novoValor.replace(/[^\d.-/-]/g, '').substring(0, 5) : '';
      this.setState({ [event.target.name]: novoValor });
    }
  };
  isSalvarDisabled = () => {
    return (this.state.errorMessageNome !== '' ||
    this.state.nomDentista === undefined ||
    this.state.nomDentista === '') ||

    (this.state.errorMessageCpfCgc !== '' ||
    this.state.numCpfCgc === undefined ||
    this.state.numCpfCgc === '') ||

    (this.state.errorMessageTelefone !== '' ||
    this.state.numFone === undefined ||
    this.state.numFone === '');

  }

  handleClickSave = async () => {
    const dentista = {
      codDentista: this.state.codDentista,
      nomDentista: this.state.nomDentista,
      numCro: this.state.numCro === undefined ? 0 : this.state.numCro,
      numCpfCgc: Number(this.state.numCpfCgc.replace(/[^0-9]/g, '')),
      numFone: Number(this.state.numFone.replace(/[^0-9]/g, '')),
    };
    await this.props.handleSave(dentista);
  }
  handleBlurNome = () => {
    if (this.state.nomDentista === '' || this.state.nomDentista === null || this.state.nomDentista === undefined) {
      this.setState({errorMessageNome: 'Favor preencher o Nome'});
    } else {
      this.setState({errorMessageNome: ''});
    }
  }
  handleChangeRadio = event => {
    if (this.state.indPessoaFisicaInicial === event.target.value) {
      this.setState({ indPessoaFisica: event.target.value, cpfCnpj: this.state.cpfCnpjInicial });
    } else {
      this.setState({ indPessoaFisica: event.target.value, cpfCnpj: '' });
    }
  }
  handleBlurCpfCnpj = () => {
    if (this.state.numCpfCgc === '' || this.state.numCpfCgc === null || this.state.numCpfCgc === undefined) {
      this.setState({errorMessageCpfCgc: 'Favor preencher o CPF/CNPJ'});
    } else {
      this.setState({errorMessageCpfCgc: ''});
      if (this.state.indPessoaFisica === 'S' && this.state.numCpfCgc.length !== 14) {
        this.setState({errorMessageCpfCgc: 'Favor preencher o CPF'});
      }
      if ((this.state.indPessoaFisica === 'N' || this.state.indPessoaFisica === undefined) &&
      this.state.numCpfCgc.length !== 18) {
        this.setState({errorMessageCpfCgc: 'Favor preencher o CNPJ'});
      }
    }
  }
  handleBlurTelefone = () => {
    if (this.state.numFone === '' ||
        this.state.numFone === null ||
        this.state.numFone === undefined ||
        (this.state.numFone.length !== 9 &&
        this.state.numFone.length !== 10)) {
      this.setState({errorMessageTelefone: 'Favor preencher o Telefone'});
    } else {
      this.setState({errorMessageTelefone: ''});
    }
  }

  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='sm'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <FormControl>
                  <TextField
                    autoFocus
                    disabled={!this.props.isEditavel}
                    id='nomDentista'
                    name='nomDentista'
                    value={this.state.nomDentista}
                    margin='dense'
                    fullWidth
                    onChange={this.handleChangeTextField}
                    className={classes.textFieldNomDentista}
                    error={this.state.errorMessageNome !== ''}
                    label={this.state.errorMessageNome !== '' ? this.state.errorMessageNome : '* Nome'}
                    onBlur={this.handleBlurNome}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
                <FormControl className={classes.controlRadio}>
                  <FormControlLabel
                    disabled={!this.props.isEditavel}
                    label='Pessoa Jurídica'
                    className={classes.radio}
                    control={<Radio
                      checked={this.state.indPessoaFisica === 'N' || this.state.indPessoaFisica === undefined}
                      aria-label='Pessoa Jurídica'
                      onChange={this.handleChangeRadio}
                      value='N'
                      name='radio-juridica' />}
                  />
                  <FormControlLabel
                    disabled={!this.props.isEditavel}
                    label='Pessoa Física'
                    className={classes.radio}
                    control={<Radio
                      checked={this.state.indPessoaFisica === 'S'}
                      aria-label='Pessoa Física'
                      onChange={this.handleChangeRadio}
                      value='S'
                      name='radio-fisica' />}
                  />
                </FormControl>
                <FormControl>
                  <TextField
                    disabled={!this.props.isEditavel}
                    id='numCpfCgc'
                    name='numCpfCgc'
                    value={this.state.numCpfCgc}
                    margin='dense'
                    fullWidth
                    onChange={this.handleChangeTextField}
                    className={classes.textFieldCpfCnpj}
                    error={this.state.errorMessageCpfCgc !== ''}
                    label={this.state.errorMessageCpfCgc !== '' ? this.state.errorMessageCpfCgc : '* CPF/CNPJ'}
                    onBlur={this.handleBlurCpfCnpj}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
                <FormControl>
                  <TextField
                    disabled={!this.props.isEditavel}
                    id='numCro'
                    name='numCro'
                    value={this.state.numCro}
                    margin='dense'
                    fullWidth
                    style={{maxlength: '5'}}
                    onChange={this.handleChangeTextField}
                    className={classes.textFieldNumCro}
                    label={'CRO'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
                <FormControl>
                  <TextField
                    id='numFone'
                    name='numFone'
                    value={(this.state.numFone !== undefined && this.state.numFone !== 0) ? this.utils.formataTelefoneTextField(this.state.numFone) : ''}
                    margin='dense'
                    fullWidth
                    onChange={this.handleChangeTextField}
                    className={classes.textFieldTelefone}
                    error={this.state.errorMessageTelefone !== ''}
                    label={this.state.errorMessageTelefone !== '' ? this.state.errorMessageTelefone : 'Telefone'}
                    onBlur={this.handleBlurTelefone}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
              </FormControl>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogDentista);
